import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./styles.css";

const LGPD = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("lgpdAccepted");
    if (!accepted) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("lgpdAccepted", "true");
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div id="lgpd-banner">
      <p>
        Utilizamos cookies para personalizar conteúdos e melhorar sua experiência.
        Consulte nossa{" "}
        <Link className="lgpd-link" to="/privacy">
          Política de Privacidade
        </Link>{" "}
        para mais detalhes.
      </p>
      <button className="lgpd-button" onClick={handleAccept}>
        Aceito
      </button>
    </div>
  );
};

export default LGPD;
